/**
 * Don Lorino – samtycke till direkt leverans av digitalt porträtt.
 * - Rutan är alltid omarkerad när varukorgen renderas (läget sparas aldrig).
 * - Klick på kassaknappen utan kryss: stoppas, rutan markeras och felmeddelande visas.
 * - Klick med kryss: samtycket sparas som cart attributes och kassan öppnas.
 * - Om ett gammalt samtycke finns kvar på varukorgen och rutan inte är ikryssad tas det bort.
 */
(function () {
  if (customElements.get('dl-digital-consent')) return;

  var ATTR = 'Samtycke digital leverans';
  var ATTR_VERSION = 'Samtyckestext version';

  function updateUrl() {
    return (window.theme && theme.routes && theme.routes.cart_update_url) || '/cart/update';
  }

  function setAttributes(values) {
    return fetch(updateUrl() + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: values })
    });
  }

  function stockholmTimestamp() {
    try {
      var parts = new Intl.DateTimeFormat('sv-SE', {
        timeZone: 'Europe/Stockholm',
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', hour12: false
      }).formatToParts(new Date());
      var p = {};
      parts.forEach(function (x) { p[x.type] = x.value; });
      return p.year + '-' + p.month + '-' + p.day + ' ' + p.hour + ':' + p.minute;
    } catch (e) {
      return new Date().toISOString().slice(0, 16).replace('T', ' ');
    }
  }

  class DlDigitalConsent extends HTMLElement {
    connectedCallback() {
      this.checkbox = this.querySelector('.dl-digital-consent__input');
      this.error = this.querySelector('.dl-digital-consent__error');
      this.button = this.parentNode ? this.parentNode.querySelector('.checkout-button') : null;
      if (!this.checkbox || !this.button) return;

      this.checkbox.checked = false;
      this.submitting = false;

      if (this.dataset.attributeSet === 'true') {
        var clear = {};
        clear[ATTR] = '';
        clear[ATTR_VERSION] = '';
        setAttributes(clear).catch(function () {});
      }

      this.checkbox.addEventListener('change', () => {
        if (this.checkbox.checked) {
          this.classList.remove('is-invalid');
          this.error.hidden = true;
        }
      });

      this.onClick = this.onClick.bind(this);
      this.button.addEventListener('click', this.onClick, true);
    }

    disconnectedCallback() {
      if (this.button && this.onClick) this.button.removeEventListener('click', this.onClick, true);
    }

    onClick(e) {
      if (this.submitting) return;
      // Låt temats villkorsruta (om den är aktiverad) stoppa klicket först.
      var terms = this.parentNode.querySelector('terms-checkbox input[type="checkbox"]');
      if (terms && !terms.checked) return;
      e.preventDefault();
      e.stopImmediatePropagation();

      if (!this.checkbox.checked) {
        this.classList.add('is-invalid', 'is-shake');
        this.error.hidden = false;
        this.checkbox.focus();
        setTimeout(() => this.classList.remove('is-shake'), 400);
        return;
      }

      var values = {};
      values[ATTR] = 'Ja, ' + stockholmTimestamp();
      values[ATTR_VERSION] = this.dataset.version || '';
      this.button.setAttribute('aria-busy', 'true');

      setAttributes(values)
        .then((res) => {
          if (!res.ok) throw new Error('cart update failed');
          this.submitting = true;
          var form = this.button.form || this.button.closest('form');
          if (form && form.requestSubmit) {
            form.requestSubmit(this.button);
          } else if (form) {
            var hidden = document.createElement('input');
            hidden.type = 'hidden';
            hidden.name = 'checkout';
            hidden.value = '1';
            form.appendChild(hidden);
            form.submit();
          } else {
            window.location.href = '/checkout';
          }
        })
        .catch(() => {
          this.button.removeAttribute('aria-busy');
          this.submitting = false;
          this.error.hidden = false;
        });
    }
  }

  customElements.define('dl-digital-consent', DlDigitalConsent);
})();
